<template>
  <div class="customer-detail">
    <div class="breadcrumb">
      <i class="el-icon-arrow-left"></i>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>客户管理</el-breadcrumb-item>
        <el-breadcrumb-item>客户详情</el-breadcrumb-item>
        <el-breadcrumb-item>订单详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="line"></div>
    <div class="content">
      <div class="back">
        <span class="left"> 订单详情</span>
        <span class="go-back" @click="goBack">返回</span>
      </div>
    </div>
    <table class="p-table" border="0" cellspacing="0" cellpadding="0">
      <tr>
        <td class="title">订单时间</td>
        <td class="content">{{form.createTime}}</td>
        <td class="title">订单号</td>
        <td class="content">{{form.orderNo}}</td>
      </tr>
      <tr>
        <td class="title">订单类型</td>
        <td class="content">{{form.orderType | formatOrderType}}</td>
        <td class="title">业务名称</td>
        <td class="content">{{form.orderBusiDetailType| formatBusiDetailType}}</td>
      </tr>
      <tr>
        <td class="title">订单状态</td>
        <td class="content">{{form.orderStatus | formatOrderStatus}}</td>
        <td class="title">订单金额</td>
        <td class="content">{{form.orderAmount}} 元</td>
      </tr>
      <tr v-if="!showepName">
        <td class="title">支付方式</td>
        <td class="content" colspan="3">
         {{form.OrderPayType |formatPayType}}
        </td>
      </tr>
      <tr v-if="showepName">
        <td class="title">支付方式</td>
        <td class="content">{{form.OrderPayType |formatPayType}}</td>
        <td class="title">企业名称</td>
        <td class="content">{{form.epName}}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import Api from '@/api'
import { statusCode } from '@/config'
import { setStorageItem, getStorageItem, removeStorageItem } from '@/utils'

export default {
  name: 'PackageDetail',
  components: {},
  data() {
    return {
      showepName:false
    }
  },
  created() {
    this.form = getStorageItem('orderDetail')
  },
  mounted() {
    //代理商进入订单详情，需要展示企业名称
    if(this.$route.query.menu &&this.$route.query.menu=="agent"){
      this.showepName = true
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
  },
}
</script>
<style lang="scss" scoped>
@import "./common/table.scss";
.customer-detail {
  width: 100%;
  background-color: #fff;
  .line {
    width: 100%;
    height: 10px;
    background-color: #f7f7f7;
  }
  .breadcrumb {
    display: flex;
    height: 50px;
    background-color: #ffffff;
    line-height: 50px;
    padding-left: 15px;
    i {
      line-height: 50px;
      margin-left: 15px;
    }
    .el-breadcrumb {
      line-height: 50px;
    }
  }
  .content {
    background-color: #ffffff;
    .back {
      height: 60px;
      line-height: 60px;
      margin-top: 10px;
      background-color: #ffffff;
      display: flex;
      justify-content: space-between;
      position: relative;
      border-bottom: 1px solid #eee;
      .left {
        margin-left: 40px;
        font-size: 18px;
        font-family: Adobe Heiti Std;
        font-weight: normal;
        color: rgba(51, 51, 51, 1);
      }
      span.go-back {
        margin-right: 30px;
        font-size: 14px;
        font-weight: 500;
        color: rgba(36, 85, 206, 1);
        cursor: pointer;
      }
    }
  }
}
</style>
